export default "__VITE_ASSET__CleMng1i__"